export default "__VITE_ASSET__BKm6v4di__";